import { render, staticRenderFns } from "./TabelaResultadosAcompanhamento.vue?vue&type=template&id=ef78d8b8&scoped=true&"
import script from "./TabelaResultadosAcompanhamento.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosAcompanhamento.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosAcompanhamento.vue?vue&type=style&index=0&id=ef78d8b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef78d8b8",
  null
  
)

export default component.exports